import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ActionPanel } from "components/panel/ActionPanel";
import { GridLayout } from "components/grid";
import { Numeric } from "components/formatting";
import { DateToLocal } from "components/dates";
import { StatusBlock } from "components/status";
import { ShowHide } from "components/layout";
import { ListingTable } from "components/listing";

export function MotPanel({
    mot,
    eventOptions
}) {

    const [motStatus, setMotStatus] = useState({});
    const [motStatusBlock, setMotStatusBlock] = useState(<></>);
    const [hasDefects, setHasDefects] = useState(false);
    const defectTableHeaders = ["Defect Type", "Comment"];
    const notSet = "#808080";

    function getStatus(statusKeyName) {
        return eventOptions.eventStatuses.find(
            s => s.name.toLowerCase() === statusKeyName.toLowerCase()
        );
    }

    function getStatusText(passed, defects) {
        if (!passed) {
            return "Failed";
        }

        if (defects != null && defects.length > 0) {
            return "Passed with defects";
        }

        return "Passed";
    }

    function generateStatusBlock(passed, defects) {
        return <StatusBlock status={passed ? "green" : "red"}>{getStatusText(passed, defects)}</StatusBlock>
    }

    useEffect(() => {
        if (!mot || !eventOptions) {
            return;
        }
        //We'll use the same colours as the Event Status
        let defects = mot.defects ? mot.defects.length > 0 : false;
        let status = {};
        setHasDefects(defects);
        if (mot.passed) {
            status = defects ? getStatus("COMPLETEDWITHISSUES") : getStatus("COMPLETED");
        } else {
            status = getStatus("FAILED");
        }
        setMotStatus(status); 
        setMotStatusBlock(generateStatusBlock(mot?.passed, mot?.defects));
    }, [mot, eventOptions]);

    return (
        <Fragment>
            <div className="spacer-small">
                <ActionPanel
                    intent="info"
                    title="MOT Test"
                    colour={motStatus?.statusColour || notSet}
                >
                    <GridLayout numberOfColumns={1} className="form-group">
                        <div className="form-field">
                            <h4 className="summary-field-header">MOT Carried Out on</h4>
                            <DateToLocal format="DD/MM/YYYY HH:mm">
                                {mot?.completedDate}
                            </DateToLocal>
                        </div>

                        <div className="form-field">
                            <h4 className="summary-field-header">Test Number</h4>
                            <div>{mot?.testNumber}</div>
                        </div>

                        <div className="form-field">
                            <h4 className="summary-field-header">MOT Test Status</h4>
                            <div>{motStatusBlock}</div>
                        </div>

                        <div className="form-field">
                            <h4 className="summary-field-header">MOT Expiry</h4>
                            <DateToLocal format="DD/MM/YYYY">
                                {mot?.expiryDate}
                            </DateToLocal>
                        </div>

                        <div className="form-field">
                            <h4 className="summary-field-header">Test Location</h4>
                            <div>{mot?.testLocation}</div>
                        </div>

                        <div className="form-field">
                            <h4 className="summary-field-header">Test Odo Reading</h4>
                            <div>{mot?.odometerReading != null ? <span><Numeric>{mot.odometerReading}</Numeric> km</span> : "Unknown"}</div>
                        </div>
                    </GridLayout>
                    <ShowHide
                        evaluator={hasDefects}
                        show={(
                            <div>
                                <p className="intro-text">The following defects were raised as a result of your test:</p>
                                <ListingTable
                                    headers={defectTableHeaders}
                                    pageable={false}
                                    loadingData={false}
                                    totalRecordCount={mot?.defects.length}
                                    data={mot?.defects && mot?.defects.map(function (defect) {
                                        return [defect.defectType, defect.comment]
                                    })}
                                />
                            </div>
                        )}
                    />
                </ActionPanel>
            </div>
        </Fragment>
    );
}

MotPanel.propTypes = {
    mot: PropTypes.object,
    eventOptions: PropTypes.object.isRequired
};